import { graphql, useStaticQuery } from 'gatsby'

export const usePageLinks = () => {
  const data = useStaticQuery(graphql`
    query {
      allWpPage {
        nodes {
          slug
          uri
          title
          language {
            code
          }
          translations {
            uri
            title
            language {
              code
            }
          }
        }
      }
    }
  `)

  // Build a slug map { key: { EN: { uri, title }, EL: { uri, title } } }
  const slugMap = {}

  data.allWpPage.nodes.forEach((page) => {
    const key = page.slug
    if (!slugMap[key]) slugMap[key] = {}

    slugMap[key][page.language.code] = {
      uri: page.uri,
      title: page.title,
    }

    page.translations.forEach((trans) => {
      slugMap[key][trans.language.code] = {
        uri: trans.uri,
        title: trans.title,
      }
    })
  })

  return slugMap
}
